<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Increment List</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="goTo('/hrm/add-increment-v2')"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Increment
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"                    
                                    density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.increment_type="{ item }">
                                            {{ incrementTypes(item.increment_type) }}
                                        </template>
                                        
                                        <template v-slot:item.increment_date="{ item }">
                                            {{ formatDateView(item.increment_date) }}
                                        </template>

                                        <template v-slot:item.effect_date="{ item }">
                                            {{ formatDateView(item.effect_date) }}
                                        </template>

                                        <template v-slot:item.approval_status_display="{ item }">
                                            <v-chip
                                            v-if="item?.approval_current_process && item?.approval_current_process?.status === 'Pending'"
                                            color="yellow-darken-3"
                                            size="small"
                                            >
                                                Wating for {{ item?.approval_current_process?.approval_step_name?.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item?.approval_current_process && item?.approval_current_process?.status === 'Approved'"
                                            color="green"
                                            size="small"
                                            >
                                                Approved By {{ item?.approval_current_process?.approval_step_name?.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item?.approval_current_process && item?.approval_current_process?.status === 'Cancelled'"
                                            color="red"
                                            size="small"
                                            >
                                                Cancelled By  {{ item?.approval_current_process?.approval_step_name?.name }}
                                            </v-chip>
                                            
                                            <v-chip
                                            v-else
                                            color="green"
                                            size="small"
                                            >   
                                                {{ item.approval_status }}
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                              
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath) && item.approval_status === 'Pending'"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { formatDateView, incrementTypes } from '@/plugins/helpers';


export default {
        components: {},
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code",align: "left" ,sortable: false },
                { title: "Employee Name", key: "employee.name",align: "left" ,sortable: false },
                { title: "Increment Type", key: "increment_type",align: "left" ,sortable: false },
                { title: "Increment Date", key: "increment_date",align: "left" ,sortable: false },
                { title: "Effect Date", key: "effect_date",align: "left" ,sortable: false },
                { title: "Gross Salary", key: "after_gross_salary",align: "left" ,sortable: false },
                { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        
        watch: {},
        created(){
            // if (this.$store.getters.getHrmIncrementList.length === 0) {
                this.loading = true;
                this.$store.dispatch("getIncrementList")
                .then(() => {
                    this.loading = false;
                });
            // }
        },

        computed:{
            getSchema() {
                console.log(this.$store.getters.getHrmIncrementList);
                return this.$store.getters.getHrmIncrementList;
            },
        },
        setup() {},
        methods: {
            formatDateView,
            incrementTypes,
            goTo(val) {
                this.$router.push({ path: val });
            },
            editItem(item){
                this.$router.push({ 
                    path: 'add-increment-v2', 
                    query: { id: item.id }
                });
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Name', 'Email', 'Mobile', 'VAT', 'BIN', 'Address', 'Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.name, item.email, item.mobile, item.vat, item.bin, item.address, item.status == 1 ? 'Active' : 'Inactive']);
                this.$exportTableToPDF(columns,rows,'Customer List','customer_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Code', 'Name', 'Email', 'Mobile', 'VAT', 'BIN', 'Address', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.email, item.mobile, item.vat, item.bin, item.address, item.status == 1 ? 'Active' : 'Inactive']);
                });
                this.$exportTableToExcel(data,'customer_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Code', 'Name', 'Email', 'Mobile', 'VAT', 'BIN', 'Address', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.email, item.mobile, item.vat, item.bin, item.address, item.status == 1 ? 'Active' : 'Inactive']);
                });

                this.$exportTableToCSV(data,'customer_list_' + this.$fileDate());
            },
        },
        mounted() {}  
    }
</script>